// extracted by mini-css-extract-plugin
export default {"separator":"OrSeparator_separator__rdQEP"};